import Component from '../core/Component'
import { toggleClass } from '../utils/dom'

const STATES = {
    ACTIVE: 'is-active',
    READY: 'is-ready'
}

export default class StringAnimator extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            items: []
        }

        this.current = 0
    }

    prepare() {
        this.element.classList.add(STATES.READY)
    }

    next() {
        this.select((this.current + 1) % this.ref.items.length)
    }

    select(index) {
        this.current = index
        this.ref.items.forEach((item, i) => toggleClass(item, STATES.ACTIVE, index === i))
    }
}